// core stuff
import React, { useState, useEffect } from "react";
import { Modal, Button, Container, Nav, Navbar } from "react-bootstrap";

import TopBannerEmailConfirmation from "./EmailConfirmation/TopBannerEmailConfirmation.js";
import UserLoader from "./UserLoader.js";

const BASE_URL = window.REACT_APP_BASE_URL;
const userObj = window.REACT_APP_USER_OBJ;
let isMobile = false;

function HeaderPart() {
	const [navExpand, setNavExpand] = useState("lg");
	const [navExpanded, setNavExpanded] = useState(false);
	const [width, setWidth] = useState(window.innerWidth);
	const [isAdmin, setIsAdmin] = useState(false);


	useEffect(() => {
		isMobile = window.innerWidth < 992 ? true : false;
		ifIsAdmin();
	}, []);

	const ifIsAdmin = () => {
		if (userObj != null) {
			let roles = userObj.roles;
			roles.forEach((role) => {
				if (role.code == "admin") {
					setIsAdmin(true);
				}
			});
		} else {
			return;
		}
	};

	const toggleNavBars = () => {
		setNavExpanded(!navExpanded);
	};

	const handleWindowSizeChange = () => {
		setWidth(window.innerWidth);
		isMobile = window.innerWidth < 992 ? true : false;
		setNavExpanded(false);
	};

	useEffect(() => {
		window.addEventListener("resize", handleWindowSizeChange);
		return () => {
			window.removeEventListener("resize", handleWindowSizeChange);
		};
	}, []);

	var header = (
		<>
			<UserLoader />
			<TopBannerEmailConfirmation />
			<Container fluid className="position-relative z-1">
				<Navbar
					expand={navExpand}
					expanded={navExpanded}
					variant="light"
					className="kn-navbar border-bottom pt-0 pb-0 bg-white">
					<Container>
						<div className="d-flex align-items-center kn-logo">
							<a
								href={window.REACT_APP_ROUTER_BASENAME}
								className="navbar-brand">
								<img
									className="img-fluid"
									src="public/images/shared/logo.svg"
								/>
							</a>
							<span className="kn-clear-planet">
								<img
									className="img-fluid"
									src="public/images/shared/cleanPlanetLogo.svg"
								/>
							</span>
						</div>

						<button
							className="navbar-toggler"
							type="button"
							onClick={() => toggleNavBars()}>
							<span className="navbar-toggler-icon"></span>
						</button>

						<Navbar.Collapse
							id="basic-navbar-nav"
							className="navbar-nav me-auto mb-2 mb-lg-0">
							<Nav className="me-auto justify-content-end flex-grow-1">
								{/* <ul className="navbar-nav kn-menu"> */}
								<ul className="navbar-nav">
									<li className="nav-item">
										<a
											href={window.REACT_APP_ROUTER_BASENAME + "/about"}
											className="nav-link">
											ABOUT THIS PROGRAM
										</a>
									</li>
									{/* <li className="nav-item">
                    <a
                      href={window.REACT_APP_ROUTER_BASENAME + "/contact"}
                      className="nav-link">
                      CONTACT US
                    </a>
                  </li> */}
								</ul>
							</Nav>
						</Navbar.Collapse>
					</Container>
				</Navbar>
			</Container>
			{userObj != null ? (
				<>
					<Container fluid className={"position-relative z-1 " + (isMobile ? "bg-white" : "bg-dark")}>
						<Container>
							<Navbar
								variant={isMobile ? "light" : "dark"}
								className="pt-0 pb-0"
								expand={navExpand}
								expanded={navExpanded}>
								<Navbar.Collapse
									id="user-navbar"
									className="navbar-nav me-auto mb-2 mb-lg-0">
									<Nav className="me-auto justify-content-end flex-grow-1">
										<ul className="navbar-nav kn-menu">
											{isAdmin ? (
												<li className="nav-item">
													<a
														href={
															window.REACT_APP_ROUTER_BASENAME +
															"/user-management"
														}
														className="nav-link">
														User Administration
													</a>
												</li>
											) : (
												""
											)}

											<li className="nav-item">
												<a
													href={
														window.REACT_APP_ROUTER_BASENAME + "/my-account"
													}
													className="nav-link">
													Edit My Account
												</a>
											</li>
											<li className="nav-item">
												<a
													href={window.REACT_APP_ROUTER_BASENAME + "/logout"}
													className="nav-link">
													Log Out
													<i className="bi bi-box-arrow-right ms-2"></i>
												</a>
											</li>
										</ul>
									</Nav>
								</Navbar.Collapse>
							</Navbar>
						</Container>
					</Container>
				</>
			) : (
				""
			)}
		</>
	);

	return header;
}

export default HeaderPart;
